/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Component, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { UsersFilter } from 'app/page-modules/tenant-management/models';
import { FormGroup, FormControl, AbstractControl } from '@angular/forms';

@Component({
  selector: 'og-tenant-users-filter',
  templateUrl: './tenant-users-filter.component.html',
  styleUrls: ['./tenant-users-filter.component.scss'],
  standalone: false
})
export class TenantUsersFilterComponent implements AfterViewInit {
  /** Emitted any time the user makes a change to the filter. */
  @Output() filterUpdated = new EventEmitter<UsersFilter>();

  filterFormGroup = new FormGroup({
    domainOpengamma: new FormControl(true),
    domainOthers: new FormControl(true),
    nameQuery: new FormControl('')
  });

  ngAfterViewInit(): void {
    setTimeout(() => this.updateFilter());
  }

  updateFilter(): void {
    const updatedFilter: UsersFilter = {
      showOpengammaUsers: this.domainOpengamma.value,
      showOtherUsers: this.domainOthers.value,
      nameQuery: this.nameQuery.value
    };
    this.filterUpdated.next(updatedFilter);
  }

  get domainOpengamma(): AbstractControl {
    return this.filterFormGroup.get('domainOpengamma')!;
  }

  get domainOthers(): AbstractControl {
    return this.filterFormGroup.get('domainOthers')!;
  }

  get nameQuery(): AbstractControl {
    return this.filterFormGroup.get('nameQuery')!;
  }
}
